import Vue from 'vue'

const packageJson = require('../package.json')


export const state = () => ({
  API: process.env.API_URL,
  RESOURCES_URL: process.env.RESOURCES_URL,
  URL: null,
  IS_FIREBASE: packageJson.IS_FIREBASE,
  messages: {},
  params: [],
  pathWithoutLocale: '',
  currentPageKey: '',
  currentDir: '',
  participantObj: {},
  errorObj: {},
  windowWidth: 0,
  doodleStaticImageList: [],
  doodleMovingImageList: [],
  doodle4kImage: {},
})

export const getters = {
  API: state => state.API,
  URL: state => state.URL,
  RESOURCES_URL: state => state.RESOURCES_URL,
  IS_FIREBASE: state => {
    return state.IS_FIREBASE ? '/.json' : ''
  },
  messages: state => state.messages,
  errorMeta: state => state.errorObj.meta
}

export const mutations = {
  SET_CURRENT_DIR(state, key) {
    state.currentDir = key
  },
  SET_CURRENT_PAGE_KEY(state, key) {
    Vue.set(state, 'currentPageKey', key)
  },
  SET_MESSAGES(state, { messages, keyData }) {
    state.messages[keyData] = messages
  },
  SET_URL(state, url) {
    state.URL = url
  },
  SET_CURRENT_PARAMS(state, arr) {
    state.params = arr

    var array = Object.keys(arr).map(function(key) {
      return arr[key]
    })

    array.shift()

    let fullPath = ''

    if (array.length === 0) {
      fullPath = ''
    } else {
      fullPath = array.join('/')
    }

    state.pathWithoutLocale = fullPath
  },
  SET_PARTICIPANT(state, obj) {
    state.participantObj = obj
  },
  SET_ERROR(state, obj) {
    state.errorObj = obj
  },
  setWindowWidth(state) {
    try {
      state.windowWidth = window && window.innerWidth || 0;
    } catch (e) { }
  },
  setDoodleImageList(state, { propName, data }) {
    state[propName] = data;
  },
  setDoodle4kImage(state, { propName, data }) {
    state.doodle4kImage[propName] = data;
  },
}

export const actions = {
  async GET_PAGE_DATA({ commit, state, getters }, obj) {
    let key = null
    let paramsArray = obj.params.replace(/\/$/, '').split('/')
    const isGa = paramsArray[1] ? paramsArray[1].slice(0, 1) : ''

    commit('SET_CURRENT_PARAMS', paramsArray)

    if (paramsArray.length === 1 || isGa === '?') {
      key = 'index'
      paramsArray = `/index`
    } else {
      key = paramsArray[paramsArray.length - 1]
      paramsArray = paramsArray.join('/')
    }

    commit('SET_CURRENT_PAGE_KEY', key)

    const messages = state.messages

    if (messages.hasOwnProperty(key)) {
      console.log(
        `%cData of ${key} page exist 💾`,
        'color: #0dbc79; background: rgba(13, 188, 121, 0.2); border-radius: 10px; padding: 5px'
      )
      return
    }

    console.log(
      `GET Page data: ${state.API}${paramsArray}${getters.IS_FIREBASE}`
    )

    try {
      const data = await this.$axios.get(
        `${state.API}${paramsArray}${getters.IS_FIREBASE}`
      )

      const keyData = key,
        messages = data.data

      if (messages === null || messages === undefined || messages.error) {
        throw {
          statusCode: 404,
          message: `${e}`,
          errorObj: 'test'
        }
      }

      commit('SET_MESSAGES', {
        messages,
        keyData
      })
    } catch (e) {
      console.log('data: ', e)
      throw {
        statusCode: 404,
        message: `${e}`
      }
    }
  },

  async GET_GLOBAL_MESSAGES({ commit, state, getters }, url) {
    const baseLink = state.API,
      globalString = 'global',
      globalData = `${baseLink}/${globalString}${getters.IS_FIREBASE}`,
      messages = state.messages

    if (messages.hasOwnProperty(globalString)) {
      console.log(
        `%cData of ${globalString} page exist`,
        'color: #0dbc79; background: rgba(13, 188, 121, 0.2);'
      )
      return
    }

    try {
      const data = await this.$axios.get(globalData)
      const keyData = globalString
      const messages = data.data

      commit('SET_MESSAGES', {
        messages,
        keyData
      })

      commit('SET_URL', url)
    } catch (e) {
      console.log(e)
    }
  },
  async getHomePageData({ state, commit }) {
    if (state.doodleStaticImageList.length && state.doodleMovingImageList.length) {
      return;
    }

    try {
      const { data } = await this.$axios.get('/home-page');
      const doodle = data && data.doodle || {};

      Object.keys(doodle).forEach(key => {
        const item = {
          key: key.toLowerCase(),
          src: doodle[key],
        };

        if (item.key.includes('static')) {
          if (item.key.includes('4k')) {
            commit('setDoodle4kImage', {
              propName: 'static',
              data: item.src,
            });
          } else {
            commit('setDoodleImageList', {
              propName: 'doodleStaticImageList',
              data: [
                ...state.doodleStaticImageList,
                item,
              ],
            });
          }
        } else {
          if (item.key.includes('4k')) {
            commit('setDoodle4kImage', {
              propName: 'moving',
              data: item.src,
            });
          } else {
            commit('setDoodleImageList', {
              propName: 'doodleMovingImageList',
              data: [
                ...state.doodleMovingImageList,
                item,
              ],
            });
          }
        }
      });
    } catch (e) {
      console.error(e);
      return;
    }

    commit('setDoodleImageList', {
      propName: 'doodleStaticImageList',
      data: state.doodleStaticImageList.filter(sItem => {
        const conformity = state.doodleMovingImageList
          .find(mItem => mItem.key.includes(sItem.key.replace('static', '')));
        return sItem.src && conformity && conformity.src;
      }),
    });

    commit('setDoodleImageList', {
      propName: 'doodleMovingImageList',
      data: state.doodleMovingImageList.filter(mItem => {
        const conformity = state.doodleStaticImageList
          .find(sItem => sItem.key.includes(mItem.key.replace('moving', '')));
        return mItem.src && conformity && conformity.src;
      }),
    });

    ['doodleStaticImageList', 'doodleMovingImageList'].forEach(key => {
      commit('setDoodleImageList', {
        propName: key,
        data: state[key].map(item => {
          return { ...item }
        }).sort((a, b) => {
          if (a.key.replace(/\d/g, '') !== b.key.replace(/\d/g, '')) {
            return a.key.localeCompare(b.key);
          }
          return parseInt(a.key.replace(/\D/g, '')) - parseInt(b.key.replace(/\D/g, ''));
        }).map((item, i, arr) => {
          if (i) {
            const key = item.key.includes('more') ? item.key : arr[i - 1].key;
            item.width = parseInt(key.replace(/\D/g, ''));
          } else {
            item.width = 0;
          }
          return item;
        }).sort((a, b) => a.width - b.width),
      });
    });
  }
}



// WEBPACK FOOTER //
// ./store/data.js